import React, { Component } from 'react';
import { toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import { Table } from 'antd';

@inject('apiToolsStore')
@observer
class SearchResult extends Component {
  onSelectChange = (selectedRowKeys, selectedRows) => {
    const { apiToolsStore } = this.props
    this.setState({ selectedRowKeys, selectedRows });
    apiToolsStore.onChangeSelectedRowKeys(selectedRowKeys,selectedRows)
  }
  getRowClassName = (record, index) => {
    let className = '';
    className = index % 2 === 0 ? 'oddRow' : 'evenRow';
    return className;
  }
  render() {
    const { apiToolsStore } = this.props
    const { resultList, selectedRowKeys } =apiToolsStore
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };
      return (
        <>
          <Table className='searchResult' dataSource={toJS(resultList)} pagination={false} rowClassName={this.getRowClassName} rowSelection={rowSelection} rowKey="id"  bordered>
            <Table.Column title='Object Type' dataIndex="transportationDataType" key="transportationDataType" />
            <Table.Column title='Object Name' render={(text,record)=>
            record.apiType==='MAPPING'?
              <>
                {record.apiName}
              </>:
              <>
                <span style={{fontWeight: 500}}>Connect Type: </span>{record.apiType}<br /><span style={{fontWeight: 500}}>Connect Name: </span>{record.apiName}
              </>
            } />
          </Table>
        </>
      );
  }
}

export default SearchResult;
